module.exports = __webpack_public_path__ + "static/media/Bg4.45925717.svg";